<template>
  <div class="loader">
    <div class="message">
      {{ message }}
    </div>
    <LoaderIcon />
  </div>
</template>

<script>
// eslint-disable-next-line
import LoaderIcon from '~/static/loading.svg?inline';

export default {
  name: 'LegacyLoading',
  components: {
    LoaderIcon,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes rotate360 {
  to { transform: rotate(360deg); }
}

.loader {
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    animation: 2s rotate360 infinite linear;
    width: 100px;
    height: 100px;
  }

  .message {
    font-size: 14px;
  }
}
</style>
